import {
	faChartArea,
	faChartSimpleHorizontal,
	faFilter,
	faHeat,
	faChartLineUp,
	faChartPie,
	faCircleDot,
	faDiagramSankey,
	faChartScatter,
	faChartScatterBubble,
	faTable,
	faCloudWord,
	faChartSimple,
	faLollipop,
	faChartPyramid,
	faDiagramNested,
	faGauge,
	faSlider,
	faChartTreeMap,
	faCompass,
} from '@fortawesome/pro-light-svg-icons';
import { ChartTypesEnum } from '../../enums/chart-types.enum';
import { faChartBullet, faChartWaterfall } from '@fortawesome/pro-regular-svg-icons';

export const ChartIconMap = {
	[ChartTypesEnum.Area]: faChartArea,
	[ChartTypesEnum.Bar]: faChartSimpleHorizontal,
	[ChartTypesEnum.Chart]: faTable,
	[ChartTypesEnum.Funnel]: faFilter,
	[ChartTypesEnum.Heat]: faHeat,
	[ChartTypesEnum.Heatmap]: faHeat,
	[ChartTypesEnum.Line]: faChartLineUp,
	[ChartTypesEnum.Packed]: faChartScatterBubble,
	[ChartTypesEnum.Pie]: faChartPie,
	[ChartTypesEnum.Donut]: faCircleDot,
	[ChartTypesEnum.Sankey]: faDiagramSankey,
	[ChartTypesEnum.Scatter]: faChartScatter,
	[ChartTypesEnum.WordCloud]: faCloudWord,
	[ChartTypesEnum.Column]: faChartSimple,
	[ChartTypesEnum.Lollipop]: faLollipop,
	[ChartTypesEnum.Pyramid]: faChartPyramid,
	[ChartTypesEnum.Solidgauge]: faGauge,
	[ChartTypesEnum.Columnrange]: faSlider,
	[ChartTypesEnum.Treemap]: faChartTreeMap,
	[ChartTypesEnum.Stackedbar]: faChartSimpleHorizontal,
	[ChartTypesEnum.Stackedcolumn]: faChartSimple,
	[ChartTypesEnum.Clusteredline]: faChartLineUp,
	[ChartTypesEnum.Clusteredbar]: faChartSimpleHorizontal,
	[ChartTypesEnum.Clusteredcolumn]: faChartSimple,
	[ChartTypesEnum.Dependencywheel]: faDiagramNested,
	[ChartTypesEnum.Arearange]: faChartArea,
	[ChartTypesEnum.Areasplinerange]: faChartArea,
	[ChartTypesEnum.Xrange]: faSlider,
	[ChartTypesEnum.Gauge]: faGauge,
	[ChartTypesEnum.Variablepie]: faChartPie,
	[ChartTypesEnum.Pyramid3d]: faChartPyramid,
	[ChartTypesEnum.Columnpyramid]: faChartSimple,
	[ChartTypesEnum.Cylinder]: faChartSimple,
	[ChartTypesEnum.Stackedline]: faChartLineUp,
	[ChartTypesEnum.Polar]: faCompass,
	[ChartTypesEnum.Bullet]: faChartBullet,
	[ChartTypesEnum.Waterfall]: faChartWaterfall,
};
